import { render, staticRenderFns } from "./PrintJournalInvoice.vue?vue&type=template&id=71e6c3eb"
import script from "./PrintJournalInvoice.vue?vue&type=script&lang=js"
export * from "./PrintJournalInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports